export default __webpack_public_path__ + "static/media/Component6.977abeff.png";